import { useMemo } from "react"
import { FormProvider, useForm } from "react-hook-form"
import InputGroup from "../../common/form/inputGroup"
import Label from "../../common/form/label"
import useCheckoutContext, {
  useActiveStep,
  useArticle,
  usePaymentAmount,
  useProduct,
  useArticleTitle
} from "../store"
import { useAppContext } from "@/lib/contexts/appContext"
import SubmitStepButton from "../user-details/submitStepButton"

function Article() {
  let { articles } = useProduct()
  const { campaignName, label } = useActiveStep()
  const { setCampaignName } = useAppContext()
  const { article, setArticle } = useArticle()
  const { setArticleTitle } = useArticleTitle()
  const { setNextActiveStep } = useCheckoutContext()
  const { setPaymentAmount } = usePaymentAmount()

  articles = articles.filter((article) => article.IsOptional)

  const defaultArticle = articles.find((article) => article.IsDefault)
  const options = useMemo(
    () =>
      articles.map((article) => {
        return {
          value: article.ArticleId,
          name: article.ArticleName
        }
      }),
    [articles]
  )

  const methods = useForm({
    defaultValues: {
      article: article ?? defaultArticle?.ArticleId ?? options[0]?.value ?? ""
    },
    mode: "onBlur"
  })

  const { register } = methods

  const onSubmit = (values) => {
    setArticle(values.article)
    setCampaignName(campaignName)

    const article = articles.find(
      (article) => article.ArticleId === +values.article
    )
    if (article.PriceType === "Fast pris" && article.Price) {
      setPaymentAmount(article.Price, false)
    }

    setArticleTitle(article.ArticleName)
    setNextActiveStep()
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <InputGroup>
          <Label required={true} name="article">
            {label || "Välj"}
          </Label>
          <div className="relative w-full">
            <select
              id="article"
              {...register("article")}
              className="block w-full py-2 pl-4 pr-8 text-lg leading-tight bg-white border rounded appearance-none border-black-50 focus:outline-none focus:shadow-outline">
              {options.map((option) => (
                <option key={option?.key ?? option.value} value={option.value}>
                  {option.name}
                </option>
              ))}
            </select>
            <div className="absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 pointer-events-none">
              <svg
                className="w-4 h-4 fill-current"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20">
                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
              </svg>
            </div>
          </div>
        </InputGroup>
        <SubmitStepButton />
      </form>
    </FormProvider>
  )
}

export default Article
